// Configuration for Application Insights
export const appInsightsConfig = {
    connectionString: '', // Will be populated from API
    enabled: true // Will be set based on environment
};

// Function to fetch Application Insights config from backend
export const fetchAppInsightsConfig = async (): Promise<void> => {
    try {
        // Disable Application Insights in local development
        const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        if (isLocalDevelopment) {
            console.log('Application Insights disabled in development mode');
            appInsightsConfig.enabled = false;
            return;
        }

        const response = await fetch('/api/config');
        if (response.ok) {
            const config = await response.json();
            appInsightsConfig.connectionString = config.applicationInsightsConnectionString || '';
        } else {
            console.warn('Failed to fetch Application Insights configuration');
        }
    } catch (error) {
        console.warn('Error fetching Application Insights configuration:', error);
    }
};
